import { useEffect } from "react";

/**
 * Sans titre par page, chaque onglet ouvert affiche le même
 * "scraping-for-sales" — impossible de retrouver une fiche précise parmi
 * plusieurs onglets ouverts en parallèle, ce qu'un commercial fait en préparant
 * une série d'appels.
 */
export function useTitre(titre?: string | null): void {
  useEffect(() => {
    document.title = titre ? `${titre} — scraping-for-sales` : "scraping-for-sales";
    return () => { document.title = "scraping-for-sales"; };
  }, [titre]);
}
